import { FileActionButton } from "../file-action/file-action-controls";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useEffect, useState, useRef } from "react";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";
import { Toast } from "primereact/toast";

interface GrnReportsSearchProps {
  onExport: () => void;
  onSearch: (filters: {
    rawMaterialId?: number;
    supplierId?: number;
    rmCategoryId?: number;
    activeOnly?: boolean;
    startDate?: string;
    endDate?: string;
    keyword?: string;
    invoiceNumber?: string;

    posAlias?: string;
    isGRNReport?: boolean;
  }) => void;
  onReset: () => void;
  totalRecords: number;
}

const GrnReportsSearch: React.FC<GrnReportsSearchProps> = ({
  onSearch,
  onReset,
  onExport,
  totalRecords,
}) => {
  const [MaterialId, setMaterialId] = useState<number | null>(null);
  const [Rawmaterials, setRawmaterials] = useState<any[]>([]);
  const [category, setCategory] = useState<any[]>([]);
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [keyword, setKeyword] = useState<string>("");
  const toast = useRef<Toast>(null);
  const [InvoiceNos, setInvoiceNos] = useState<{ invoiceNumber: string }[]>([]);
  const [selectedInvoiceNo, setSelectedInvoiceNo] = useState<string | null>(null);
  const [posList, setPosList] = useState<any[]>([]);
  const [selectedPosAlias, setSelectedPosAlias] = useState<string | null>(null);




  useEffect(() => {
    const fetchRawMaterials = async () => {
      try {
        const response = await RawMaterialService.getRawMaterials();
        setRawmaterials(response || []);
      } catch (error) {

      }
    };

    const fetchCategories = async () => {
      try {
        const response = await RawMaterialService.RMCategories();
        setCategory(response || []);
      } catch (error) {

      }
    };

    const fetchPosList = async () => {
      try {
        const response = await RawMaterialService.GetManufacrturingunitlist();
        setPosList(response || []);
      } catch (error) {

      }
    };

    const fetchInvoiceNos = async () => {
      try {
        const response = await RawMaterialService.getInvoicenos();

        setInvoiceNos(response || []);
      } catch (error) {

      }
    };

    fetchRawMaterials();
    fetchCategories();
    fetchInvoiceNos();
    fetchPosList();
  }, []);

  const formatDateWithoutTimezone = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSearch = () => {
    if (
      !keyword.trim() &&
      !MaterialId &&
      !categoryId &&
      !startDate &&
      !endDate &&
      !selectedInvoiceNo &&
      !selectedPosAlias
    ) {
      toast.current?.show({
        severity: "warn",
        summary: "⚠️ Missing Filters",
        detail: "Please choose at least one filter.",
        life: 4000,
      });
      return;
    }

    if (startDate && !endDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing Date",
        detail: "Please select an End Date to complete the range.",
        life: 4000,
      });
      return;
    }

    if (!startDate && endDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing Date",
        detail: "Please select a Start Date to complete the range.",
        life: 4000,
      });
      return;
    }

    if (startDate && endDate && endDate < startDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "End Date cannot be earlier than Start Date.",
        life: 3000,
      });
      return;
    }

    onSearch({
      rawMaterialId: MaterialId || undefined,
      rmCategoryId: categoryId || undefined,
      startDate: startDate ? formatDateWithoutTimezone(startDate) : undefined,
      endDate: endDate ? formatDateWithoutTimezone(endDate) : undefined,
      keyword: keyword.trim(),
      invoiceNumber: selectedInvoiceNo || undefined,
      posAlias: selectedPosAlias || undefined,
      isGRNReport: true
    });
    setFilterApplied(true);
  };

  const handleReset = () => {
    setMaterialId(null);
    setCategoryId(null);
    setStartDate(null);
    setEndDate(null);
    setFilterApplied(false);
    setKeyword("");
    setSelectedInvoiceNo(null);
    setSelectedPosAlias(null);
    onReset();
  };

  return (
    <div className="card p-4 w-full" style={{
      backgroundColor: '#e8f5e9',
      borderRadius: '12px'
    }}>
      <Toast ref={toast} />

      <div className="flex flex-wrap align-items-center justify-content-between gap-3">
        <div style={{ flex: "1 1 18%" }}>
          <InputText
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="Search keyword"
            className="w-full"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
          />
        </div>

        <div style={{ flex: "1 1 18%" }}>
          <Dropdown
            panelClassName="grn-dropdown-panel"
            id="id"
            name="id"
            value={MaterialId}
            options={Rawmaterials}
            optionLabel="name"
            optionValue="id"
            placeholder="Select Raw Material"
            onChange={(e) => setMaterialId(e.value)}
            className="w-full"
            filter
            filterBy="name"
            showFilterClear
            filterMatchMode="startsWith"
            filterPlaceholder="Search raw materials..."
          />
        </div>

        <div style={{ flex: "1 1 18%" }}>
          <Dropdown
            panelClassName="grn-dropdown-panel"
            value={selectedInvoiceNo}
            options={InvoiceNos}
            optionLabel="invoiceNumber"
            optionValue="invoiceNumber"
            placeholder="Select Invoice Number"
            onChange={(e) => setSelectedInvoiceNo(e.value)}
            className="w-full"
            filter
            filterBy="invoiceNumber"
            showFilterClear
            filterMatchMode="startsWith"
          />
        </div>

        <div style={{ flex: "1 1 18%" }}>
          <Dropdown
            id="categoryID"
            name="categoryID"
            value={categoryId}
            options={category}
            optionLabel="categoryName"
            optionValue="categoryID"
            placeholder="Select Category"
            onChange={(e) => setCategoryId(e.value)}
            className="w-full"
            filter
            filterBy="categoryName"
            filterMatchMode="startsWith"
            showFilterClear
          />
        </div>

        <div style={{ flex: "1 1 18%" }}>
          <Dropdown
            panelClassName="grn-dropdown-panel"
            value={selectedPosAlias}
            options={posList}
            optionLabel="posAlias"
            optionValue="posAlias"
            placeholder="Select Unit"
            onChange={(e) => setSelectedPosAlias(e.value)}
            className="w-full"
            filter
            showClear
          />
        </div>

        <div className="flex flex-wrap gap-3 w-full mt-2">
          <div style={{ flex: "1 1 11%" }}>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              placeholder="Start Date"
              dateFormat="dd-mm-yy"
              readOnlyInput
              inputRef={(el) => {
                if (el) el.readOnly = true;
              }}
              className="w-full"
            />
          </div>

          <div style={{ flex: "1 1 11%" }}>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              placeholder="End Date"
              dateFormat="dd-mm-yy"
              readOnlyInput
              inputRef={(el) => {
                if (el) el.readOnly = true;
              }}
              className="w-full"
            />
          </div>

          <div
            style={{ flex: "1 1 25%" }}
            className="flex gap-2 justify-content-end align-items-center"
          >
            <FileActionButton action="export"
              label="Export"
              icon="pi pi-file-excel"
              className="p-button-success"
              onClick={onExport}
              style={{ width: "100px" }}
              disabled={totalRecords === 0}
            />

            <Button
              label="Filter"
              className="p-button-success"
              onClick={handleSearch}
              style={{ width: "100px" }}
            />
            <Button
              label="Reset"
              className="text-black border-round p-button-m"
              severity="secondary"
              text
              raised
              onClick={handleReset}
              style={{ width: "100px" }}
            />
          </div>
        </div>
      </div>

      {filterApplied && (
        <div className="col-12 mt-2 text-sm">
          <span className="text-black font-semibold text-lg">
            Number of GRN Reports: {totalRecords}
          </span>
        </div>
      )}
    </div>
  );
};

export default GrnReportsSearch;
